import React from 'react';
import './ClickToCopy.scss';

import { Tools, Popup } from '../../../services'

interface Props {
  title?: string;
  toCopy: string;
}
const ClickToCopy: React.FC<Props> = (props) => {

  const copy = () => {
    Tools.copyToClipboard(props.toCopy)
    const message = 'Lien copié dans le presse papier !'
    Popup.show({
      type: 'info',
      settings: {
        title: 'Copié !',
        text: message
      }
    })
  }

  return (
    <div className={"click-to-copy "} onClick={copy}>
      <div className="link">{props.title || props.toCopy}</div>
      <div className="icon"><i className="fa fa-copy"></i></div>
    </div>
  );
}

export default ClickToCopy;
